/** Safari's audio-session switch (`navigator.audioSession`, iOS 16.4+), for the iOS mic (2026-10-26).
 *
 *  The iPhone logs of 2026-10-26 showed the second voice prompt hearing
 *  nothing after Scout had spoken: speech synthesis leaves iOS in playback,
 *  and the recogniser then captures silence.  Chat.tsx asks for
 *  "play-and-record" before recording and "playback" after.  Browsers
 *  without the API are left alone. */

export type AudioSessionType = "auto" | "playback" | "transient" | "transient-solo" | "ambient" | "play-and-record";

interface AudioSessionHost {
  audioSession?: { type: string };
}

/** Ask the browser for `type` of audio session; returns false when it has no `navigator.audioSession`. */
export function setAudioSession(
  type: AudioSessionType,
  nav: AudioSessionHost | undefined = typeof navigator !== "undefined" ? (navigator as AudioSessionHost) : undefined,
): boolean {
  const session = nav?.audioSession;
  if (!session) return false;
  try {
    session.type = type;
  } catch {
    return false;
  }
  return true;
}
